// Marque blanche (white-label) du portail, pilotée par la conf tenant.
// Le tenant porte une clé `branding` (ex. "UNIVOIP"). Absente => marque Heedify par défaut.
// On ne brande que le logo du Header (post-login, tenant connu).

import logoHeedify from "../Assets/logo.png";
import logoUnivoip from "../Assets/UniVoIP_Logo_1.svg";

const BRANDS = {
  // lightHeader : bandeau d'en-tête blanc (logo bleu UniVoIP visible) au lieu du gris foncé.
  UNIVOIP: { name: "UniVoIP", navLogo: logoUnivoip, lightHeader: true },
};

const DEFAULT_BRAND = { name: "Heedify", navLogo: logoHeedify };

/**
 * Renvoie la config de marque pour une clé de branding (insensible à la casse).
 * Tout ce qui n'est pas mappé retombe sur Heedify.
 */
export const getBrand = (brandingKey) => {
  if (!brandingKey) return DEFAULT_BRAND;
  return BRANDS[String(brandingKey).toUpperCase()] || DEFAULT_BRAND;
};
